import axios from 'axios'
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';


axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    //   config.baseURL = 'http://127.0.0.1:8000/api';
    //   config.baseURL = 'http://192.168.1.117:8000/api';
    //         config.baseURL = 'http://192.168.110.247:8000/api';
    //     config.baseURL = 'http://79.175.151.22:8000/api';
    //        config.baseURL = 'http://127.0.0.1:8000/api';
            config.baseURL = 'https://corporate.mihmansho.com/apibtob/core';
    // config.baseURL = 'http://192.168.110.238:8000/api';
    // config.baseURL = 'http://192.168.110.249:8000/api';
    //       config.baseURL = '/api';
     config.headers = {'Authorization': localStorage.getItem('token')};
    // config.headers = {'Authorization': 'Token 09e5f4deb50c376aab8afb18efa71b54e21c6f51'};
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    debugger;
    // if (response.data.detail === 'Invalid token.') {
    //        localStorage.setItem('user_id', '');
    //     store.dispatch(userSignOut());
    //     window.location.reload();
    //     //  this.history.push('/signin');
    //     return;
    // }

    debugger;
    return response;
}, function (error) {
    debugger;


    if (error.response.status === 401) {
        // store.dispatch(userSignOut());
        // localStorage.setItem('user_id','');
        // this.history.push('/signin');
        // this.props.history.push('/some/path');
        //   return ( <Redirect to={'/signin'}/> );
        // const errorDispatcher = useErrorDispatcher();
        // errorDispatcher('sad');


        //ok
        // const store = configureStore();
        // store.dispatch(userSignOut());
        localStorage.setItem('token', '');
        return;
    }
    if (error.response.status === 500) {
        // alert('خطای سرور');
        // const MySwal = withReactContent(Swal);
        // MySwal.fire({
        //     icon: 'error',
        //     title: 'خطا', showCancelButton: false,
        //     showConfirmButton: true,
        //     confirmButtonText: 'باشه',
        //     text: 'خطای سرور!',
        // });
    }

    if (error.response.status === 400) {

        // const MySwal = withReactContent(Swal);
        // MySwal.fire({
        //             icon: 'error',
        //             title: 'خطا', showCancelButton: false,
        //             showConfirmButton: true,
        //             confirmButtonText: 'باشه',
        //             text: error.response.data.errorDescription,
        //         });
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
                icon: 'error',
                title: error.response.data.errorDescription
            })
            return;



    }


    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});


export const ListEmployee = (pagenumber,pagesize,q,status,companyid) => {

    return axios.get('/createemployee',{params: {pagenumber: pagenumber,pagesize:pagesize,q:q,typestatus:status,companyid:companyid}})
};
export const ListCompanyMain = (pagenumber,pagesize,q,status) => {

    return axios.get('/createcompany',{params: {pagenumber: pagenumber,pagesize:pagesize,q:q,typestatus:status}})
};
export const ListCompanyLittle = () => {

    return axios.get('/listcompany')
};

export const GetProfile = () => {

    return axios.get('/getprofile')
};

export const GetReason = () => {

    return axios.get('/getreason')
};

export const EditProfileUser = (data) => {

    return axios.put('/getprofile',data)
};


export const login = (data) => {
    debugger;
    return axios.post('/login', data)
};


export const gettransaction = (data) => {
    debugger;
    return axios.post('/gettransaction', data)
};


export const gettransactioncompany = (data) => {
    debugger;
    return axios.post('/gettransactioncompany', data)
};

// export const gettransactioncompany = (pagenumber,pagesize,q,startdate,enddate) => {
//     debugger;
//     return axios.get('/gettransactioncompany', {params: {pagenumber: pagenumber,pagesize:pagesize,q:q,startdate:startdate,enddate:enddate}})
// };



export const gettransactionuser = (pagenumber,pagesize,q,startdate,enddate,typereason,companyid) => {
    debugger;
    return axios.get('/gettransactionuser', {params: {pagenumber: pagenumber,pagesize:pagesize,q:q,startdate:startdate,enddate:enddate,typereason:typereason,companyid:companyid}})
};

export const gettransactionrealuser = (pagenumber,pagesize,q,companyid,typereason) => {
    debugger;
    return axios.get('/gettransactionrealuser', {params: {pagenumber: pagenumber,pagesize:pagesize,q:q,companyid:companyid,typereason:typereason}})
};


export const createemployee = (data) => {
    debugger;
    return axios.post('/createemployee', data)
};

export const editemployee = (data) => {
    debugger;
    return axios.put('/createemployee', data)
};


export const createcompany = (data) => {
    debugger;
    return axios.post('/createcompany', data)
};

export const editcompany = (data) => {
    debugger;
    return axios.put('/createcompany', data)
};
export const deletecompany = (id) => {
    debugger;
    return axios.delete('/createemployee', {params: {id: id}})
};




export const addcredit = (data) => {
    debugger;
    return axios.post('/addcredit', data)
};


export const addcreditcompany = (data) => {
    debugger;
    return axios.post('/addcreditcompany', data)
};



export const uploadexele = (data) => {
    debugger;
    return axios.post('/uploadexele', data)
};

export const updateemployee = (data) => {
    debugger;
    return axios.put('/createemployee', data)
};


export const deleteemployee = (id) => {
    debugger;
    return axios.delete('/createemployee', {params: {id: id}})
};

export const CreditUser = () => {

    return axios.get('/credituser')
};


export const GetDashboard = () => {

    return axios.get('/getdashboard')
};



export const sendticket2 = (data) => {

    return axios.post('/saveticket2', data)
};
export const sendnodeticket2 = (data) => {

    return axios.post('/savenodeticket2', data)
};

export const getticket2 = (pagenumber,pagesize,q,companyid) => {

    return axios.get('/getticket2', {params: {pagenumber: pagenumber,pagesize:pagesize,q:q,companyid:companyid}})
};

export const getnodeticket2 = (data) => {

    return axios.post('/getnodeticket2',data)
};


export const defaultimage = (address) => {

    // return 'http://127.0.0.1:8000'+address;
    // return 'http://79.175.151.22:7977'+address;
    return 'https://corporate.mihmansho.com'+address;

};










